<ion-row
	(click)="isEmptyArticle || (group && !group.hasMultiple) ? add.emit() : null"
	[class.selected]="selected > 0"
	class="item-selectable-article"
>
	<ion-col>
		<ion-row>
			<ion-col>
				<ion-img [src]="article.assets.large" class="item-selectable-article-image ion-no-margin ion-no-padding"></ion-img>
				<ion-row class="quantity-row">
					@if (group && group.hasMultiple && !isEmptyArticle) {
						<app-quantity-selector
							(decrease)="remove.emit()"
							(increase)="add.emit()"
							[quantity]="selected"
						></app-quantity-selector>
					}
				</ion-row>
			</ion-col>
		</ion-row>
		<div class="name">
			{{ article.name | langObservable | async }}
			<app-tag [tags]="article.tags"></app-tag>
		</div>
		@if (price > 0) {
			<b class="option-price"> +{{ numberToCurrency(price, currency) }} </b>
		}
	</ion-col>
</ion-row>
